<template>
  <div style="padding-left: 1rem;">
    <div>
      <div class="fields-wrapper" data-type="reports">
        <div class="search-wrapper">
          <b-input-group size="sm" class="search-bar">
            <b-input-group-prepend is-text class="search-bar-icon">
              <b-icon icon="search"></b-icon>
            </b-input-group-prepend>

            <b-form-input
              autocomplete="off"
              type="search"
              placeholder="Digita un report da ricercare"
              size="sm"
              v-model="searchedTerms"
              @keyup="filterData"
            >
            </b-form-input>
          </b-input-group>
        </div>
      </div>
      <div
        class="mt-3 no-res"
        v-if="
        accountingReports.length === 0 &&
        homeReports.length === 0 &&
        insuranceAncillariesReports.length === 0 &&
        walletReports.length === 0 &&
        dailyAccountingReports.length === 0 &&
        smacReports.length === 0
      "
      >
        Non ci sono report che corrispondono alla ricerca
      </div>
      <div class="my-3 reports-wrapper">
        <div class="form-card-wrapper">
          <b-card
            v-if="hasAccessToHome && homeReports.length > 0"
          >
            <template #header>
              <b>Report Homepage</b>
            </template>
            <b-card-text>
              <generated-reports
                ref="homeReportsRef"
                :reports-available="homeReports"
              />
            </b-card-text>
          </b-card>
        </div>
        <div class="form-card-wrapper">
          <b-card
            v-if="hasAccessToWallet && walletReports.length > 0"
          >
            <template #header>
              <b>Report Portafoglio</b>
            </template>
            <b-card-text>
              <generated-reports
                ref="walletReportsRef"
                :reports-available="walletReports"
              />
            </b-card-text>
          </b-card>
        </div>
        <div class="form-card-wrapper">
          <b-card
            v-if="
          hasAccessToInsuranceAncillary &&
          insuranceAncillariesReports.length > 0
        "
          >
            <template #header>
              <b>Report Titoli</b>
            </template>
            <b-card-text>
              <generated-reports
                ref="insuranceAncillariesReportsRef"
                :reports-available="insuranceAncillariesReports"
              />
            </b-card-text>
          </b-card>
        </div>
        <div class="form-card-wrapper">
          <b-card
            v-if="hasAccessToAccounting && accountingReports.length > 0"
          >
            <template #header>
              <b>Report Contabilità</b>
            </template>
            <b-card-text>
              <generated-reports
                ref="accountingReportsRef"
                :reports-available="accountingReports"
              />
            </b-card-text>
          </b-card>
        </div>
        <div class="form-card-wrapper">
          <b-card
            v-if="hasAccessToAccounting && dailyAccountingReports.length > 0"
          >
            <template #header>
              <b>Report Contabilità Giornaliera</b>
            </template>
            <b-card-text>
              <generated-reports
                ref="dailyAccountingReportsRef"
                :reports-available="dailyAccountingReports"
              />
            </b-card-text>
          </b-card>
        </div>
        <div class="form-card-wrapper">
          <b-card
            v-if="hasAccessToSmac && smacReports.length > 0"
          >
            <template #header>
              <b>Report SMaC</b>
            </template>
            <b-card-text>
              <generated-reports
                ref="smacReportsRef"
                :reports-available="smacReports"
              />
            </b-card-text>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GeneratedReports from "@/components/GeneratedReports";
import {canModule} from "@/utils/permissions";

export default {
  data() {
    return {
      reports: null,
      filteredDailyAccountingReports: [],
      filteredHomeReports: [],
      searchedTerms: null,
      initialHomeReports: [],
      initialWalletReports: [],
      initialInsuranceAncillariesReports: [],
      initialAccountingReports: [],
      initialDailyAccountingReports: [],
      initialSmacReports: [],
      walletReports: [
        "AGGRECLI",
        "MONUPROD",
        "REPONUCL",
        "POLCLIGRU",
        "PORTATTI",
        "SINPRECLI" /* "SCACLIGRU",  "RUBRICLI" */,
      ], // module.PFOLIO.REPG
      insuranceAncillariesReports: [
        "TITULTIGI",
        "REPOLEX",
        "RECATIIN",
        "REDETIIN",
        "TITINCACLI",
      ], // module.TIT.REPO
      accountingReports: [
        "INCAPAGA",
        "COMINCA",
        "INCACOMP",
        "INCACOMP2",
        "INCACLIGRU",
        "INCACOL",
        "INCARAM",
        "RENCOMP",
        "VIPENSIONO",
        "INCAPROD" /*  "RENPROD", "INCARAMTI" */,
      ], // module.CONT.REPO
      dailyAccountingReports: ["EXPOCOGI"],
      smacReports: ["SMAC"], // module.CONT.REPO + AgencySetup SMAC
      homeReports: ["REPAPP", "REPATT"], // module.HOME.REPG
    };
  },
  methods: {
    canModule,
    filterData(event) {
      const inputValue = event.target.value;

      const filteredHomeReports = this.reports
        .filter((report) => report.section === "home")
        .filter(
          (option) =>
            option.text.toLowerCase().includes(inputValue.toLowerCase()) ||
            option.code.toLowerCase().includes(inputValue.toLowerCase())
        )
        .map((opt) => opt.code);
      this.homeReports = filteredHomeReports.filter((report) =>
        this.initialHomeReports.map((rep) => report === rep)
      );

      const filteredWalletReports = this.reports
        .filter((report) => report.section === "wallet")
        .filter(
          (option) =>
            option.text.toLowerCase().includes(inputValue.toLowerCase()) ||
            option.code.toLowerCase().includes(inputValue.toLowerCase())
        )
        .map((opt) => opt.code);
      this.walletReports = filteredWalletReports.filter((report) =>
        this.initialWalletReports.map((rep) => report === rep)
      );

      const filteredInsuranceAncillariesReports = this.reports
        .filter((report) => report.section === "insurance_ancillaries")
        .filter(
          (option) =>
            option.text.toLowerCase().includes(inputValue.toLowerCase()) ||
            option.code.toLowerCase().includes(inputValue.toLowerCase())
        )
        .map((opt) => opt.code);
      this.insuranceAncillariesReports =
        filteredInsuranceAncillariesReports.filter((report) =>
          this.initialInsuranceAncillariesReports.map((rep) => report === rep)
        );

      const filteredAccountingReports = this.reports
        .filter((report) => report.section === "accounting")
        .filter(
          (option) =>
            option.text.toLowerCase().includes(inputValue.toLowerCase()) ||
            option.code.toLowerCase().includes(inputValue.toLowerCase())
        )
        .map((opt) => opt.code);
      this.accountingReports = filteredAccountingReports.filter((report) =>
        this.initialAccountingReports.map((rep) => report === rep)
      );

      const filteredDailyAccountingReports = this.reports
        .filter((report) => report.section === "daily_accounting")
        .filter(
          (option) =>
            option.text.toLowerCase().includes(inputValue.toLowerCase()) ||
            option.code.toLowerCase().includes(inputValue.toLowerCase())
        )
        .map((opt) => opt.code);
      this.dailyAccountingReports = filteredDailyAccountingReports.filter((report) =>
        this.initialDailyAccountingReports.map((rep) => report === rep)
      );

      const filteredSmacReports = this.reports
        .filter((report) => report.section === "smac")
        .filter(
          (option) =>
            option.text.toLowerCase().includes(inputValue.toLowerCase()) ||
            option.code.toLowerCase().includes(inputValue.toLowerCase())
        )
        .map((opt) => opt.code);
      this.smacReports = filteredSmacReports.filter((report) =>
        this.initialSmacReports.map((rep) => report === rep)
      );
    },
  },
  mounted() {
    this.initialHomeReports = Object.values(
      this.$refs.homeReportsRef.reportOptions
    ).map((option) => {
      return {
        text: option.text,
        code: option.value,
        section: "home",
      };
    });
    this.initialWalletReports = Object.values(
      this.$refs.walletReportsRef.reportOptions
    ).map((option) => {
      return {
        text: option.text,
        code: option.value,
        section: "wallet",
      };
    });
    this.initialInsuranceAncillariesReports = Object.values(
      this.$refs.insuranceAncillariesReportsRef.reportOptions
    ).map((option) => {
      return {
        text: option.text,
        code: option.value,
        section: "insurance_ancillaries",
      };
    });
    this.initialAccountingReports = Object.values(
      this.$refs.accountingReportsRef.reportOptions
    ).map((option) => {
      return {
        text: option.text,
        code: option.value,
        section: "accounting",
      };
    });
    this.initialDailyAccountingReports = Object.values(
      this.$refs.dailyAccountingReportsRef.reportOptions
    ).map((option) => {
      return {
        text: option.text,
        code: option.value,
        section: "daily_accounting",
      };
    });
    this.initialSmacReports = Object.values(
      this.$refs.smacReportsRef?.reportOptions ?? []
    ).map((option) => {
      return {
        text: option.text,
        code: option.value,
        section: "smac",
      };
    });
    this.reports = [
      ...this.initialHomeReports,
      ...this.initialWalletReports,
      ...this.initialInsuranceAncillariesReports,
      ...this.initialAccountingReports,
      ...this.initialDailyAccountingReports,
      ...this.initialSmacReports,
    ];
  },
  components: {GeneratedReports},
  computed: {
    hasAccessToWallet() {
      return canModule("module.PFOLIO");
    },
    hasAccessToInsuranceAncillary() {
      return canModule("module.TIT");
    },
    hasAccessToAccounting() {
      return canModule("module.CONT");
    },
    hasAccessToHome() {
      return canModule("module.HOME");
    },
    hasAccessToSmac() {
      return (
        canModule("module.CONT") &&
        this.$store.state.auth.settings?.attributables?.SMAC === "Y"
      );
    },
  },
};
</script>

<style>
.search-bar {
  color: var(--color-text-muted);
  outline: none !important;
  box-shadow: none !important;
  border: none !important;
}

.search-wrapper {
  margin-top: 1rem;
  position: sticky;
  top: 0;
  padding: 6px;
  border-radius: var(--radius-md);
  border: 1px solid var(--gray-100);
  background: var(--gray-200);
  z-index: 1;
}

.data-sources {
  display: grid;
  grid-template-columns: 140px 1fr;
  grid-template-rows: 50px 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  padding: 0 0 0 20px;

  .section-label {
    grid-area: 1 / 1 / 2 / 2;
  }

  .flex-container {
    grid-area: 2 / 1 / 3 / 2;
  }

  .fields-wrapper {
    background: var(--gray-200);
    grid-area: 1 / 2 / 3 / 3;
    overflow-y: auto;
    position: relative;

    &:after {
      position: sticky;
      display: block;
      width: 100%;
      height: 60px;
      left: 0;
      bottom: -10px;
      content: "";
      pointer-events: none;
      touch-action: none;
      cursor: default;
      user-select: none;
      -webkit-tap-highlight-color: transparent;
      z-index: 1;
      background: linear-gradient(0deg, #d5d5d5, hsla(0, 0%, 100%, 0));
    }
  }
}

.no-res {
  margin-top: 10px;
  padding: 0;
  text-align: center;
}

/* clears the ‘X’ from Internet Explorer */
input[type="search"]::-ms-clear {
  display: none;
  width: 0;
  height: 0;
}

input[type="search"]::-ms-reveal {
  display: none;
  width: 0;
  height: 0;
}

/* clears the ‘X’ from Chrome */
input[type="search"]::-webkit-search-decoration,
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-results-button,
input[type="search"]::-webkit-search-results-decoration {
  display: none;
}

/* Search */
</style>
